import { render, staticRenderFns } from "./TuokeLeadDialog.vue?vue&type=template&id=6881903c&scoped=true"
import script from "./TuokeLeadDialog.vue?vue&type=script&lang=js"
export * from "./TuokeLeadDialog.vue?vue&type=script&lang=js"
import style0 from "./TuokeLeadDialog.vue?vue&type=style&index=0&id=6881903c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881903c",
  null
  
)

export default component.exports